module.exports = __webpack_public_path__ + "img/star-bubble.3766a5d6.svg";